import React from 'react';
import styled, { css } from 'styled-components';
import { white, blue500, neutral600 } from '@prezi/common-design';

interface SwitchProps extends React.InputHTMLAttributes<HTMLInputElement> {
    inputRef?: any;
    onEnterKeyPress?: () => void;
}

const SwitchContainer = styled.label<SwitchProps>`
    display: flex;
    position: relative;
    width: 46px;
    height: 24px;
    transition: all 0.4s;
    border-radius: 24px;
    pointer-events: auto;
    background-color: ${neutral600};
    border: 1px solid ${neutral600};
    opacity: 0.4;
    cursor: pointer;
    margin-bottom: 0;
    flex-shrink: 0;
    ${props =>
        props.checked &&
        css`
            opacity: 1;
            background-color: ${({ theme }) => theme.bento.colors.primary.main};
            border-color: ${({ theme }) => theme.bento.colors.primary.main};
        `}
`;

const SwitchKnob = styled.div<SwitchProps>`
    position: absolute;
    height: 24px;
    width: 24px;
    bottom: -1px;
    left: -1px;
    background-color: ${white};
    border: 1px solid ${neutral600};
    border-radius: 50%;
    transition: 0.4s;
    pointer-events: auto;
    ${props =>
        props.checked &&
        css`
            border-color: ${blue500};
            transform: translateX(22px);
        `}
`;

const SwitchInput = styled.input`
    display: none;
`;

export const Switch: React.FC<SwitchProps> = ({ inputRef, onEnterKeyPress, disabled, ...props }) => {
    const { defaultChecked, checked } = props;

    return (
        <SwitchContainer
            checked={defaultChecked || checked}
            tabIndex={disabled ? -1 : 0}
            onKeyPress={(event: React.KeyboardEvent) => event.key === 'Enter' && !disabled && onEnterKeyPress?.()}
        >
            <SwitchInput type="checkbox" role="switch" ref={inputRef} disabled={disabled} {...props} />
            <SwitchKnob checked={defaultChecked || checked} />
        </SwitchContainer>
    );
};
